module.exports = __webpack_public_path__ + "media/images/athletes/4157-79b816bf3a7dacf572e50b3079d7e16c.png";